// Chevron-down — sourced verbatim from
//   design/UI : UX v1.0/for-engineering-shell/assets/icon-chevron.svg
// Used by UserMenu trigger + native select-like dropdowns. Rotate via CSS
// transform on the parent (e.g. open-state) — the SVG itself isn't rotated.

import type { SVGProps } from 'react';

export function ChevronDownIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      fill="none"
      role="img"
      aria-label="Chevron down"
      {...props}
    >
      <path
        d="M2.5 4.5 L6 8 L9.5 4.5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
